'use strict';

export default {
  slices: {
    formAdmin: {
      fieldSectionError: "Créez une section avant d'ajouter des champs",
      fieldStepError: "Créez une étape ainsi qu'une section avant d'ajouter des champs",
    },
  },
};
